/**
 * The `?shippingDocumentId=` URL param key that opens `ManifestsV3`'s
 * bill-of-lading drawer. Kept distinct from `processedManifestId` (a path
 * segment, not a query param) so the manifest drawer and the bill-of-lading
 * drawer can never collide in the URL, and kept in its own module so
 * `manifestsV3DrawerNavigation.ts` and `ManifestsV3.tsx` share one constant.
 */
export const SHIPPING_DOCUMENT_PARAM_KEY = "shippingDocumentId";
